<template>
  <div>
    <home-carousel />
    <div class="main-max-width">
      <div class="knews">
        <div class="news-img">
          <img :src="require(`@/assets/${$store.getters.currentTheme}/images/bullhorn.svg`)" alt="">
        </div>

        <div
          ref="marqueeContainer"
          class="news-body"
          @mouseenter="stopMarquee"
          @mouseleave="startMarquee"
        >
          <!-- eslint-disable-next-line -->
          <a v-for="(item, key) in marqueeDetails" :key="key" :style="marqueeStyle" @click="goNewsPage(key+1)" v-html="item.title"
          />
        </div>
        <a class="news-more" @click="goNewsPage('')">{{ $t('Bao.news_more') }}<i class="fa-solid fa-angle-right" /></a>
      </div>
      <!-- 中間區塊-遊戲類別 -->
      <div v-if="isShowLobby" class="game-quick-link game-filters-list lobby-filters-list">
        <ul ref="gameFilterContainer">
          <li v-for="(type, key) in gameType" :key="type.id" :class="{ 'active': isGameTypeActive(type) }" @click.stop="changeGameType(type)">
            <picture>
              <img :src="gameType[key].image_pc_icon" :alt="gameType[key].name">
            </picture>
            <span>{{ gameType[key].name }}</span>
          </li>
        </ul>
      </div>
      <VueSlickCarousel
        v-else-if="!isShowLobby && gameType && gameType.length !== 0"
        v-bind="slick_setting"
        class="slick-list slick-div"
      >
        <div
          v-for="(type, key) in gameType"
          :key="key"
          class="games-type"
          @click.stop="changeGameType(type)"
        >
          <img v-if="$store.getters.currentTheme==='theme_gold'&& isMobile()" class="h5" :src="gameType[key].image_h5_icon" :alt="gameType[key].name">
          <img v-else class="pc" :src="gameType[key].image_big" :alt="gameType[key].name">
        </div>
        <template #prevArrow="">
          <i class="jp-slick-arrow"><img :src="require(`@/assets/${$store.getters.currentTheme}/images/home-arrow-left.png`)" alt=""></i>
        </template>
        <template #nextArrow="">
          <i class="jp-slick-arrow"><img :src="require(`@/assets/${$store.getters.currentTheme}/images/home-arrow-right.png`)" alt=""></i>
        </template>
      </VueSlickCarousel>
      <div ref="gameFilter" class="game-quick-link">
        <div class="lobby-search-bar">
          <ul>
            <li @click="showSearchProvider()">
              <i><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-filter.png`)" alt=""></i><span>{{ $t("Bao.provider_name") }}</span>
            </li>
            <li class="search-box" @click="showSearchGame()">
              <div class="slot-animation">
                <span>{{ $t('Bao.search_games_text1') }}</span>
                <span id="workHour" class="font-weight-bold work_hour font-xl">0</span>
                <span>{{ $t('Bao.search_games_text2') }}</span>
              </div>
            </li>
          </ul>
        </div>
        <VueSlickCarousel
          v-if="$store.getters.gameCategory && showGame && currentFilterObj.type !== 'type' && currentFilterObj.type !== 'provider' && !this.$store.state.user.isGameFilterActive"
          ref="slickCarousel"
          :key="carouselKey"
          class="slider provider-container list"
          v-bind="slick_setting_2"
        >
          <div
            v-for="(item, key) in showGame"
            :key="key"
            ref="gameCategory"
            :class="{ active: isGameCategoryActive(item) }"
            @click="changeGameCategory(item)"
          >
            <a>
              <img :src="item.image_banner" alt="">
            </a>
          </div>
          <template #prevArrow="">
            <i class="jp-slick-arrow"><img :src="require(`@/assets/${$store.getters.currentTheme}/images/home-arrow-left.png`)" alt=""></i>
          </template>
          <template #nextArrow="">
            <i class="jp-slick-arrow"><img :src="require(`@/assets/${$store.getters.currentTheme}/images/home-arrow-right.png`)" alt=""></i>
          </template>
        </VueSlickCarousel>
        <div class="game-card-background">
          <div class="game-card-list">
            <div
              v-for="(game) in displayedGames.slice(0, totalDisplayedGames)"
              :key="game.id"
              class="game-card"
              :class="{ active: game.showDetail }"
            >
              <div class="game-card-name">
                <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new" />
                <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot active" />
                <div class="game-tx">
                  <span class="game-name" @click="handleLaunchGame(game)">{{ game.name }}</span>
                  <span class="game-provider" @click="handleLaunchGame(game)">{{ game.game_provider_name }}</span>
                </div>
                <div class="game-info">
                  <i class="game-info-icon" @click="showDetail(game)" />
                  <i v-if="$store.getters.token" class="game-info-icon-heart" :class="{ active:game.isFavorite }" @click.stop="handleFavoriteGame(game)" />
                  <i v-if="game.brand_game_category_id.includes('NO BONUS')" class="game-info-icon-nobonus" />
                </div>
              </div>
              <div v-if="$store.getters.token" class="game-card-image" @click="handleLaunchGame(game)">
                <d-img :src="game" :alt="game.name" />
              </div>
              <div v-else class="game-card-image">
                <picture>
                  <div class="demoplay-frame">
                    <d-img :src="game" :alt="game.name" />
                    <div class="demoplay-box">
                      <button class="btn btn-demoplay" @click="openLoginModal">{{ $t('Bao.play_game') }}</button>
                      <button v-if="game.demo_url" class="btn btn-gotoplay" @click="openDemoGame(game)">{{ $t('Bao.demo') }}</button>
                    </div>
                  </div>
                </picture>
              </div>
              <div class="game-card-info">
                <div class="close" @click="closeDetail(game)">
                  ✕
                </div>
                <span v-show="game.rtp!==-1">{{ $t("Bao.rtp") }}：</span>
                <span v-show="game.rtp!==-1">{{ (game.rtp * 100).toFixed(2) }}%</span>  <!-- 將小數點轉化為百分比，取值至小數點後兩位 -->
                <span v-show="game.yesterday_rtp!==-1">{{ $t("Bao.rtp_yesterday") }}：</span>
                <span v-show="game.yesterday_rtp!==-1">{{ game.yesterday_rtp }}%</span>
                <span>{{ $t("Bao.bet_range") }}：</span>
                <span>{{ $store.state.brand.currency }}{{ game.bet_amount_range.split('~')[0] }} - {{ $store.state.brand.currency }}{{ game.bet_amount_range.split('~')[1] }}</span>
                <span v-show="game.max_odds!==-1">{{ $t("Bao.max_odds") }}：</span>
                <span v-show="game.max_odds!==-1">{{ game.max_odds }} {{ $t("Bao.max_odds_multiply") }}</span>
                <button @click="handleLaunchGame(game)">
                  <span>{{ $t("Bao.play_game_now") }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="game-more">
            <button v-show="displayedGames.length > page.size + (page.num - 1) * 20" class="button-style-6" @click="nextPage">
              <span>{{ $t('Bao.game_more') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- 中間區塊-新事件 -->
      <div class="new-events">
        <div class="h4">
          {{ $t('Bao.new_event') }}
        </div>
        <ul>
          <li v-for="(event, key) in $store.state.game.gameCategory" v-show="event.enable_banner" :key="key">
            <img :src="event.image_banner_app" alt="" @click="handleClick(event.banner_url)">
            <span>{{ event.banner_name }}</span>
          </li>
        </ul>
      </div>
      <!-- 中間區塊-供應商 -->
    </div>
    <search-provider ref="searchProvider" @change-provider="changeGameProvider" />
    <search-game ref="searchGame" :all-game="allGame" />

    <iframe-game v-show="gameUrlFromStore" :all-game="allGame" />
    <performance-modal :is-active="gameModalOpen" />  <!-- 遊戲開啟前文案 每日一次 -->
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { getShowOffGameBets, getGames, getGameList, getProviderNum, getGameNum, getTypeMenuInfo } from '@/api/game'
import { addFavoriteGame, removeFavoriteGame, updateToken } from '@/api/user'
import { getMarqueeDetail } from '@/api/brand'
import { showToast } from '@/utils/tool'
import { gameStart, gameEnd } from '@/utils/games'
import dImg from '@/components/dynamicImg'
import homeCarousel from '@/components/homeCarousel'
import performanceModal from '@/components/modal/performanceModal'
import iframeGame from '@/components/modal/iframeGame'
import { detectMob } from '@/utils/tool'
import searchProvider from '@/components/popup-box/searchProvider'
import searchGame from '@/components/popup-box/searchGame'
import { mapMutations } from 'vuex'
import { CountUp } from 'countup.js'
export default {
  name: 'Index',
  components: {
    VueSlickCarousel,
    performanceModal,
    dImg,
    homeCarousel,
    searchProvider,
    searchGame,
    iframeGame
  },
  data() {
    return {
      allGame: [],
      showOffGameBets: [],
      favoriteGames: [],
      favoriteAll: [],
      selectedTab: null,
      currentFilterObj: {
        type: 'category', // 'type', 'provider'
        value: process.env.VUE_APP_DEFAULT_GAME_CATEGORY_ID
      },
      games: [],
      marqueeDetails: [],
      positionX: 100,
      speed: 0.8,
      isRunning: false,
      animationFrameId: null,
      page: {
        num: 1,
        total: 0,
        size: 10,
        incrementSize: 20
      },
      initGetGames: false,
      nowCategory: {},
      isFirstRender: true,
      workHourVal: 0,
      carouselKey: 0, // 初始 key 值
      slick_setting: {
        draggable: true,
        infinite: true,
        dots: false,
        initialSlide: 0,
        focusOnSelect: true,
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      },
      slick_setting_2: {
        draggable: true,
        infinite: true,
        dots: false,
        initialSlide: 0,
        focusOnSelect: false,
        slidesToShow: 8,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  computed: {
    showGame() {
      if (this.$store.getters.token && this.favoriteAll.length > 0) {
        const customItem = {
          image_banner: require(`@/assets/${this.$store.getters.currentTheme}/images/icon_tab_favorite.png`),
          isFavGame: true
        }
        return [customItem, ...this.$store.getters.gameCategory]
      } else {
        return this.$store.getters.gameCategory
      }
    },
    gameType() {
      return this.$store.getters.gameType
    },
    activeFilter() {
      return this.$store.state.user.activeFilter
    },
    gameModalOpen() {
      return this.$store.state.app.isModalActive
    },
    displayedGames() {
      if (this.activeFilter === 'favorites') {
        if (this.favoriteAll.length > 0) {
          return this.favoriteAll.filter(game => game.isFavorite)
        } return []
      } else {
        return this.games
      }
    },
    filterFavorList() {
      return this.favoriteAll
    },
    isShowLobby() {
      return this.currentFilterObj.type === 'type' ||
             this.currentFilterObj.type === 'provider' ||
             this.$store.state.user.isGameFilterActive
    },
    totalDisplayedGames() {
      // The initial display size is 10
      const initialSize = this.page.size
      // After the first page, each page will load 20 more games
      const additionalSize = (this.page.num - 1) * this.page.incrementSize
      return initialSize + additionalSize
    },
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    currentGameType() {
      return this.$store.state.user.currentGameType
    },
    marqueeStyle() {
      return {
        transform: `translateX(${this.positionX}px)`
      }
    }
  },
  watch: {
    '$store.state.game.gameCategory'(to) {
      if (to && !this.$store.state.user.currentGameCategory) {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', to[0])
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      }
      this.nowCategory = to[0]
    },
    '$store.state.user.currentGameCategory'(to) {
      if (to !== null) {
        this.currentFilterObj = to ? { type: 'category', value: to.id } : { type: 'favorites', value: null }
        this.getGameList()
      }
      if (this.isFirstRender) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
        this.isFirstRender = false
      } else if (this.$route.path === '/' && this.$store.state.user.currentGameType === null) {
        this.$nextTick(() => {
          this.gameScroll('gameCategory', 'gameCategory', 90, 135)
        })
      }
    },
    '$store.state.user.currentGameType'(to) {
      if (to) {
        this.currentFilterObj = {
          type: 'type',
          value: to.game_type
        }
        this.getGameList()
        this.refreshProvider(to.game_type)
        this.getProviderNum(to.game_type)
      }
      if (this.$route.path === '/' && this.$store.state.user.currentGameCategory === null) {
        this.$nextTick(() => {
          this.gameScroll('gameFilterContainer', 'gameFilter', 180, 162)
        })
      }
    },
    '$store.state.user.currentGameProvider'(to) {
      if (to !== null) {
        this.currentFilterObj = {
          type: 'provider',
          value: to.game_provider_id ? to.game_provider_id : to.id
        }
        this.getGameList()
      }
      if (this.$route.path === '/' && this.$store.state.user.currentGameProvider !== null) {
        this.$nextTick(() => {
          this.gameScroll('gameFilterContainer', 'gameFilter', 180, 162)
        })
      }
    },
    '$store.state.app.gameUrl'(newVal) {
      if (!newVal) { // if the game URL is empty
        gameEnd(this.$store.state.app.inGameId)
      }
    },
    '$store.getters.token'(newVal) {
      if (!newVal) {
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', this.$store.state.game.gameCategory[0])
      }
    }
  },
  beforeDestroy() {
    this.stopMarquee()
  },
  created() {
    if (this.$route.query.category) {
      this.currentFilterObj = {
        type: 'category',
        value: this.$route.query.category
      }
    } else if (this.$route.query.type) {
      this.currentFilterObj = {
        type: 'type',
        value: this.$route.query.type
      }
    } else if (this.$route.query.provider_id) {
      this.currentFilterObj = {
        type: 'provider',
        value: this.$route.query.game_provider_id
      }
    }
    // 曬單
    this.refreshGamesAndBets()
    this.myInterval = setInterval(() => {
      this.handleShowOffGameBets()
    }, 60000)
    // Check if the Vuex store's currentGameCategory has data
    const user = this.$store.state.user
    let gameType, gameValue, scrollToTarget
    if (user.currentGameCategory) {
      gameType = 'category'
      gameValue = user.currentGameCategory.id
      scrollToTarget = 'gameCategory'
    } else if (user.currentGameType) {
      gameType = 'type'
      gameValue = user.currentGameType.game_type
      scrollToTarget = 'gameFilterContainer'
    }
    if (gameType && gameValue) {
      this.currentFilterObj = { type: gameType, value: gameValue }
      this.getGameList()
      this.scrollToActive(scrollToTarget)
      window.scrollTo(0, 0)
      this.isFirstRender = false
    }
    if (user.isFromChampionship && !this.$store.getters.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_CHAMPIONSHIP', false)
    if (user.isFromPromotion && !this.$store.getters.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_PROMOTION', false)
    this.getGameNum()
    const favoriteGames = this.$store.state.user.favoriteGame || []
    this.updateFavoriteAll(favoriteGames)

    getMarqueeDetail().then(response => {
      this.marqueeDetails = response.data.data
      this.$nextTick(() => {
        this.startMarquee()
      })
    })
  },
  mounted() {
    this.countup()
  },
  methods: {
    startMarquee() {
      if (this.isRunning) return
      this.isRunning = true

      const moveText = () => {
        if (!this.isRunning) return
        this.positionX -= this.speed

        if (this.positionX <= -this.$refs.marqueeContainer.scrollWidth) {
          this.positionX = this.$refs.marqueeContainer.offsetWidth
        }

        this.animationFrameId = requestAnimationFrame(moveText)
      }

      moveText()
    },
    stopMarquee() {
      this.isRunning = false
      cancelAnimationFrame(this.animationFrameId)
    },
    goNewsPage(key) {
      if (key) {
        this.$store.commit('SET_CHOOSE_NEWS', key)
      }
      this.$router.push({ path: '/user/news' })
    },
    // 被選中的遊戲標籤要移動至畫面中
    scrollToActive(refName) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (refName !== 'slickCarousel') {
            const container = this.$refs[refName]
            const activeItem = container.querySelector('.active')
            if (activeItem) {
              const containerRect = container.getBoundingClientRect()
              const activeItemRect = activeItem.getBoundingClientRect()
              let scrollPosition
              if (activeItem === container.lastElementChild) {
                scrollPosition = container.scrollWidth - container.clientWidth
              } else {
                scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
              }
              container.scrollLeft = scrollPosition
            } else {
              const slickInstance = this.$refs.slickCarousel
              const activeIndex = this.showGame.findIndex(item => this.isGameCategoryActive(item))
              slickInstance.goTo(activeIndex)
            }
          }
        }, 300)
      })
    },
    gameScroll(labelName, refName, web, mobile) {
      this.scrollToActive(labelName)
      this.$nextTick(() => {
        const activeFilter = this.$refs[refName]
        if (activeFilter) {
          let offset = web
          if (detectMob()) {
            offset = mobile
          }
          const top = activeFilter.getBoundingClientRect().top + window.scrollY - offset
          window.scrollTo({ top, behavior: 'smooth' })
        }
      })
    },
    updateWorkHour(newValue) {
      this.workHourVal = newValue
      this.countup()
    },
    isMobile() {
      return detectMob()
    },
    handleClick(banner_url) {
      const id = banner_url.split('/').pop()
      this.$router.push({ path: '/event', query: { eventId: id }})
    },
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.$store.state.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)
        this.favoriteGames = response.data.data.game
        await this.updateFavoriteAll(this.favoriteGames)
        this.updateGameListLocally(game, !game.isFavorite)
        // Check if all favorite games are removed and activeFilter is 'favorites'
        if (this.activeFilter === 'favorites' && this.favoriteGames.length === 0) {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', this.$store.state.game.gameCategory[0])
          this.$store.commit('SET_ACTIVE_FILTER', 'others')
        }

        this.carouselKey += 1
      } catch (error) {
        console.error(error)
      }
    },
    // 顯示彈窗訊息
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    async updateFavoriteAll(favorArr) {
      let gamesData = []
      const favoriteGameIds = new Set(favorArr.map(favGame => favGame.game_id))
      const gamesArr = Array.from(favoriteGameIds)
      await getGameList({ game_id_list_string: JSON.stringify(gamesArr) })
        .then((response) => {
          gamesData = response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      const processedGames = gamesData
        .filter(game => game.status === 1)
        .map(game => {
          return {
            ...game,
            isFavorite: favoriteGameIds.has(game.id),
            showDetail: false
          }
        })
      // Sort the processedGames array by game.recommend_sort
      processedGames.sort((a, b) => a.recommend_sort - b.recommend_sort)
      this.favoriteAll = processedGames
    },
    updateGameListLocally(game, isFavorite) {
      this.showToast(game, isFavorite)
      const sourceGames = this.currentFilterObj.type === 'favorites' ? this.favoriteAll : this.games
      this.updateFavoriteStatus(sourceGames, game, isFavorite)
      this.updateFavoriteList()
      this.$store.commit('SET_FAVORITE_GAME', this.favoriteGames)
    },
    // 點擊愛心後，比對個別遊戲id，增刪“isFavorite” property
    updateFavoriteStatus(gameList, game, isFavorite) {
      const gameIndex = gameList.findIndex(g => g.id === game.id)
      if (gameIndex !== -1) {
        this.$set(gameList, gameIndex, {
          ...gameList[gameIndex],
          isFavorite
        })
      }
      // 在“我的最愛”底下，只能刪除不能新增，無法像其他種類直接從API取最新的資料並賦值給“this.favoriteGames”
      // if (this.currentFilterObj.type === 'favorites' && !isFavorite) {
      //  gameList.splice(gameIndex, 1)
      // }
    },
    // 需要新增“game_id”這個key，在切換種累時才有跟Vuex store比對的依據
    updateFavoriteList() {
      this.favoriteGames = this.favoriteAll
        .filter(favAllGame => favAllGame.isFavorite)
        .map(favAllGame => {
          return {
            ...favAllGame,
            game_id: favAllGame.id
          }
        })
    },
    getGameList() {
      let queryObj = {}
      if (this.currentFilterObj.type === 'category') {
        queryObj = {
          category: this.currentFilterObj.value
        }
      } else if (this.currentFilterObj.type === 'type') {
        queryObj = {
          type: this.currentFilterObj.value
        }
      } else if (this.currentFilterObj.type === 'provider') {
        queryObj = {
          provider_id: this.currentFilterObj.value
        }
      } else if (this.currentFilterObj.type === 'favorites') {
        queryObj = {
          showLoading: false
        }
      }
      if (!this.initGetGames) {
        queryObj.showLoading = false
        this.initGetGames = true
      }
      this.getGames(queryObj)
    },
    getGameNum() {
      getGameNum().then((response) => {
        this.updateWorkHour(response.data.num)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    refreshProvider(gameType) {
      let allProvider = []
      const providerDic = {}
      getTypeMenuInfo().then((response) => {
        allProvider = response.data.data
        for (const i in allProvider) {
          const index = allProvider[i].game_type
          providerDic[index] = allProvider[i].providers
        }
        providerDic[gameType].sort((a, b) => a.sort - b.sort)
        this.$store.commit('SET_GAME_PROVIDER', providerDic[gameType])
      })
    },
    getProviderNum(gameType) {
      getProviderNum().then((response) => {
        const gameSum = this.getGameSum(response.data.provider_list_num[gameType])
        this.updateWorkHour(gameSum)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getGameSum(gameData) {
      var totalNum = gameData.reduce((sum, game) => sum + game.num, 0)
      return totalNum
    },
    async getGames(queryObj) {
      let gamesData = []
      const favoriteGames = this.$store.state.user.favoriteGame || []
      const favoriteGameIds = new Set(favoriteGames.map(favGame => favGame.game_id))
      // Only make an API call if not filtering by favorites
      if (this.currentFilterObj.type !== 'favorites') {
        gamesData = await this.fetchGamesFromAPI(queryObj)
      } else {
        const gamesArr = Array.from(favoriteGameIds)
        await getGameList({ game_id_list_string: JSON.stringify(gamesArr) })
          .then((response) => {
            gamesData = response.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
      if (!gamesData.length) {
        this.games = []
        this.page.total = 0
        return
      }
      let processedGames = gamesData
        .filter(game => game.status === 1)
        .map(game => {
          return {
            ...game,
            isFavorite: favoriteGameIds.has(game.id),
            showDetail: false
          }
        })

      processedGames = processedGames.filter(game => game.is_show === '1')
      // Sort the processedGames array by game.recommend_sort
      processedGames.sort((a, b) => a.recommend_sort - b.recommend_sort)
      if (this.currentFilterObj.type === 'favorites') {
        this.favoriteAll = processedGames
      } else {
        this.games = processedGames
      }
      this.page.num = 1
      this.page.total = Math.ceil((processedGames.length - this.page.size) / this.page.incrementSize)
    },
    async fetchGamesFromAPI(queryObj) {
      const response = await getGames(queryObj)
      return response.data.data || []
    },
    async handleLaunchGame(game) {
      await gameStart('game', game)
    },
    nextPage() {
      this.page.num++
    },
    showDetail(game) {
      game.showDetail = true
      this.$forceUpdate()
    },
    closeDetail(game) {
      game.showDetail = false
      // this.$forceUpdate()
    },
    checkTokenExpiration() {
      setInterval(() => {
        const expiredTime = localStorage.getItem('expired_time')
        if (!expiredTime || new Date().getTime() > expiredTime) {
          this.updateToken()
        }
      }, 60000)
    },
    updateToken() {
      if (this.$store.getters.token) {
        updateToken({ token: localStorage.getItem('token') }).then(response => {
          const tokenData = response.data.data.token
          const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
          localStorage.setItem('expired_time', expiredTime)
          localStorage.setItem('token', tokenData.token)
        }).catch(error => {
          console.error('Error updating token', error)
        })
      }
    },
    async refreshGamesAndBets() {
      this.checkTokenExpiration()
      const response = await getGames({ showLoading: false })
      this.allGame = response.data.data
      this.handleShowOffGameBets()
      this.$store.commit('SET_ALL_GAME', this.allGame)
    },
    handleShowOffGameBets() {
      getShowOffGameBets().then((response) => {
        this.showOffGameBets = response.data.data

        this.showOffGameBets.forEach((bet) => {
          const game = this.allGame.find(game => game.game_provider_id === bet.game_provider_id)
          if (game) {
            bet.type = game.type
          }
        })

        this.$store.commit('SET_SHOW_OFF_GAME_BETS', this.showOffGameBets)
      })
    },
    isGameCategoryActive(item) {
      if (this.activeFilter === 'favorites' && item.isFavGame) return true
      // Check if the currently active filter matches the given category
      if (this.activeFilter === 'others' && this.$store.state.user.currentGameCategory && this.$store.state.user.currentGameCategory.id === item.id) {
        return true
      }
      // Check if the currentFilterObj value matches the item.id (for initial render)
      // if (this.currentFilterObj.value === item.id && this.currentFilterObj.value !== null) {
      //   return true
      // }
      return false
    },
    changeGameType(item) {
      if (this.selectedTab) {
        this.selectedTab = item
        this.$store.commit('SET_SHOW_GAME_FILTER', true)
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        this.$store.commit('SET_CURRENT_GAME_TYPE', item)
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      } else {
        setTimeout(() => {
          this.selectedTab = item
          this.$store.commit('SET_SHOW_GAME_FILTER', true)
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
          this.$store.commit('SET_CURRENT_GAME_TYPE', item)
          this.$store.commit('SET_ACTIVE_FILTER', 'others')
        }, 400)
      }
    },
    changeGameCategory(item) {
      const filterValue = item.isFavGame ? 'favorites' : 'others'
      this.$store.commit('SET_CURRENT_GAME_TYPE', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_SHOW_GAME_FILTER', false)
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      this.$store.commit('SET_ACTIVE_FILTER', filterValue)
    },
    changeGameProvider(item) {
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', item)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
    },
    ...mapMutations(['SET_SHOW_RESEARCH', 'SET_SHOW_PROVIDER']),
    showSearchProvider() {
      this.$refs.searchProvider.show()
      this.$store.commit('SET_SHOW_PROVIDER', true)
    },
    showSearchGame() {
      this.$refs.searchGame.show()
      this.$store.commit('SET_SHOW_RESEARCH', true)
    },
    isGameTypeActive(item) {
      // Check if the currently active filter matches the given category
      if (this.$store.state.user.currentGameType && this.$store.state.user.currentGameType.id === item.id) {
        return true
      }
      return false
    },
    countup() {
      const options = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: ',',
        suffix: '',
        startVal: 0,
        duration: 2.5
      }
      const demo = new CountUp('workHour', this.workHourVal, options)
      if (!demo.error) {
        demo.start()
      } else {
        console.error(demo.error)
      }
    },
    openLoginModal() {
      this.$store.commit('SET_LOGIN_OPEN', true)
    },
    openDemoGame(game) {
      this.$store.commit('SET_GAME_URL', game.demo_url)
    }
  }
}
</script>
<style>
.slick-div .slick-prev:before, .slick-div .slick-next:before {
  content: ''
}
.slick-div .slick-prev {
  top: 42%;
  display: flex;
  left: -10px;
  width: 60px;
  align-items: center;
}
.slick-div .slick-next {
  top: 42%;
  display: flex;
  right: -10px;
  width: 60px;
  align-items: center;
}
.provider-container .slick-prev:before, .provider-container .slick-next:before {
  content: ''
}
.provider-container .slick-prev {
  display: flex;
  left: -11px;
  align-items: center;
  width: 30px;
  z-index: 2;
}
.provider-container .slick-next {
  display: flex;
  right: -11px;
  width: 30px;
  align-items: center;
}
:not(.provider-container) >.slick-track[data-v-e4caeaf8] {
  position: relative;
  top: calc(50% - 46%);
  left: 0;
  display: block;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
@media (max-width: 1400px) {
  :not(.provider-container) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 50%);
  }
}
@media (max-width: 1300px) {
  :not(.provider-container) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 48%);
  }
}
@media (max-width: 1200px) {
  :not(.provider-container) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 40%);
  }
}
@media (max-width: 1100px) {
  :not(.provider-container) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 40%);
  }
}
@media (max-width: 1000px) {
  :not(.provider-container) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 37%);
  }
}

.provider-container .jp-slick-arrow img {
  min-width: 0;
}

:not(.provider-container) >.slick-initialized .slick-slide[data-v-e4caeaf8] {
  justify-content: center;
}
</style>
